module.exports = __webpack_public_path__ + "img/icon_001.ae33152.png";